import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Box, Paper, Typography, TableContainer, Table, TableRow, TableHead, TableBody, TableCell, Button, Alert, Skeleton } from "@mui/material";
import { Download, ArrowBack } from '@mui/icons-material'
import { LoadingButton } from "@mui/lab";
import { useDispatch, useSelector } from 'react-redux'
import { eventDetails } from "../../features/events/eventsSlice";
import { createFile } from "../../features/download/downloadSlice";

const initialState = { 
    attendance: { alumnos: 0, egresados: 0, profesores: 0, administrativos: 0, externos: 0, total: 0 }, 
    community: [], 
    guests: [], 
    event: { nombre: '', ponente: '', lugares: '', tipo: '', encargado: '', fecha: ''} 
}

const Details = () => {
    const { isLoading, isSending } = useSelector(state => state.progress);
    const { id } = useParams();
    const [data, setData] = useState(initialState)
    const { attendance, community, guests, event } = data;
    const [status, setStatus] = useState('idle');
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const defTypes = [1, 2, 4, 5];
    const names = ['alumnos', 'egresados', 'profesores', 'administrativos', 'externos', 'total'];
    
    const headers = ['Tipo', 'Código', 'Nombre', '', ''];
    useEffect(() => {
        if(status === 'idle') eventDetails(id, dispatch, setData, setStatus)
    }, [id, dispatch, status])

    return(
        <Container component={Paper} sx={{ p: '2em' }}>
            <Typography align="center" variant="h5">{event.tipo}: {event.nombre}</Typography>
            <Typography align="center" variant="h5">{event.encargado}: {event.ponente}</Typography>
            <Typography align="center" variant="h5">{event.lugares} | {event.fecha}</Typography>
            
            <Button onClick={() => navigate('/eventos')}  startIcon={<ArrowBack />}>Regresar</Button>
            
            <Box display={'flex'} >
                { names.map((n, i) => (
                    <Box p={1} flex={'auto'} key={i}>
                        <Typography sx={{ fontSize: '0.5em' }} align="center">{n.toUpperCase()}</Typography>
                        <Typography variant="body1" align="center"><b>{attendance[n]}</b></Typography>
                        <Typography align="center"> 
                            { attendance[n] > 0 && i < 4 ? 
                                <LoadingButton
                                    startIcon={<Download />}
                                    loading={isSending}
                                    type="button"
                                    onClick={() => createFile('constancies', { idEvento: id, rol: defTypes[i] }, dispatch, true)} 
                                    variant="outlined"
                                    color="success"
                                    title="Descargar Constancias"
                                >
                                    Constancias
                                </LoadingButton>
                            : null } 
                        </Typography>
                    </Box>
                )) }
            </Box>

            { isLoading ? <Skeleton animation='wave' height={200} /> : attendance.total > 0 ? (
                <TableContainer>
                    <Typography align="center">
                        <LoadingButton
                            startIcon={<Download />}
                            loading={isSending}
                            type="button"
                            onClick={() => createFile('event', { id }, dispatch)} 
                            variant="contained"
                            color="success"
                        >
                            REPORTE
                        </LoadingButton>
                    </Typography>
                    <Table>
                        <TableHead>
                            <TableRow>
                                { headers.map((h, i) => <TableCell key={i}>{h}</TableCell>) }
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            { community.length ? community.map(({ codigo, nombre, tipo, area, generacion }, i) => (
                                <TableRow key={i}>
                                    <TableCell>{tipo}</TableCell>
                                    <TableCell>{codigo}</TableCell>
                                    <TableCell>{nombre}</TableCell>
                                    <TableCell>{area}</TableCell>
                                    <TableCell>{generacion}</TableCell>
                                </TableRow>
                            )) : null }
                            { attendance.externos ? guests.map(({ nombre, dependencia }, i) => (
                                <TableRow key={i}>
                                    <TableCell>Externo</TableCell>
                                    <TableCell></TableCell>
                                    <TableCell>{nombre}</TableCell>
                                    <TableCell>{dependencia}</TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            )) : null }
                        </TableBody>
                    </Table>
                </TableContainer>
            ) : <Alert severity="warning">No se econtraron registros</Alert> }
        </Container>
    )
}

export default Details;